import React from "react";
import {connect} from "react-redux";
import {Dialog, Button, Typography} from "@material-ui/core";
import {CheckCircle, Cancel} from '@material-ui/icons';
import {IStore} from "../store/reducers";
import actionTypes from "../store/actionTypes";
import axios from "axios";
import {userService} from "../services/UserService";
import config from '../config.json';
import {INotificacion, IParcela, ISections} from "../types";


interface IProps {
    nombre: string
    seccion: ISections
    parcelas: IParcela[]
    close(callback: string): void
    notify(notification: INotificacion): void
    setParcelas(parcelas: IParcela[]): void
    selectSection(section: ISections): void
    setUsuarios(usuarios: Record<string, Record<string, string|number>[]>): void
}

interface IState {
}

class ConfirmacionEliminarUsuario extends React.Component<IProps, IState>{

    state:IState = {
    }

    resetData() {
        const url: string = config.url+`/get/all/usuarios`
        axios.get(
            url,
            {auth: {
                    username: `${userService.getUser()}`,
                    password: `${userService.getPass()}`
                }})
            .then((res) => {
                let data = res.data as Record<string, Record<string, string|number>[]>

                for (let level of Object.keys(data)) {
                    for (let usuario of data[level]) {
                        let parcelas = []
                        for (let parcela of this.props.parcelas) {
                            if (parcela.propietario.split(',').includes(usuario["nombre"])) parcelas.push(parcela.id)
                        }
                        let parcelas_str = parcelas.join(',')

                        axios.get(
                            config.url+`/superficie/parcelas?parcelas=${parcelas_str}`,
                            {auth: {
                                    username: `${userService.getUser()}`,
                                    password: `${userService.getPass()}`
                                }})
                            .then((res2) => {
                                usuario["superficie_usada"] = res2.data.superficie
                                usuario["n_parcelas"] = parcelas.length
                            })
                            .catch(() => {
                                this.props.notify({message: "Error solicitando datos de usuarios", variant: 'error'})
                            })

                    }
                }
                this.props.setUsuarios(res.data as Record<string, Record<string, string>[]>)
            })
            .catch(() => {
                this.props.notify({message: "Error solicitando datos de usuarios", variant: 'error'})
            })
    }

    handleDelete = () => {
        const url: string = config.url+`/eliminar/usuario?nombre=${this.props.nombre}`
        axios.get(
            url,
            {auth: {
                    username: `${userService.getUser()}`,
                    password: `${userService.getPass()}`
                }})
            .then(() => {
                axios.get(
                    config.url+'/init',
                    {auth: {
                            username: `${userService.getUser()}`,
                            password: `${userService.getPass()}`
                        }})
                    .then((res: { data: IParcela[] }) => {
                        this.props.close('')
                        this.props.setParcelas(res.data)
                        this.resetData()
                        this.props.notify({message: 'Usuario eliminado con éxito', variant: 'success'})
                    })
                    .catch(() => {})
            })
            .catch(() => {alert(`error eliminando al usuario ${this.props.nombre}`)})
    }

    render() {
        return (
            <Dialog
                open={this.props.nombre !== ''}
        onClose={() => this.props.close('')}
        PaperProps={{
            style: {
                display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: "center",
                    overflow: "hidden"
            }
        }}
        maxWidth={"lg"}
        >
        <Typography
            style={{
            fontWeight: "bold",
                fontSize: 24,
                margin: 50
        }}
    >
    ¿Quieres eliminar al usuario {this.props.nombre}?
            </Typography>
            <div
            style={{
            display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                marginBottom: 20
        }}
    >
        <Button
            style={{
            marginRight: 20
        }}
        onClick={() => this.handleDelete()}
    >
        <CheckCircle
            style={{
            height: 80,
                width: 80,
                color: "#4c9938"
        }}
        />
        </Button>
        <Button
        style={{
            marginLeft: 20
        }}
        onClick={() => this.props.close('')}
    >
        <Cancel
            style={{
            height: 80,
                width: 80,
                color: "#993847"
        }}
        />
        </Button>
        </div>

        </Dialog>
    )
    }
}

const mapStateToProps = (state: IStore) => ({
    nombre: state.navegacion.dialogs.confirmacion_eliminar_usuario,
    seccion: state.navegacion.section,
    parcelas: state.principal.parcelas
});

const mapDispatchToProps = (dispatch: (action: actionTypes) => void) => ({
    close: (callback: string) => dispatch({type: "open-confirmacion-eliminar-usuario-dialog", callback}),
    notify: (notification: INotificacion) => dispatch({type: 'notify', notification}),
    setParcelas: (parcelas: IParcela[]) => dispatch({type: "set-principal-parcelas", parcelas}),
    selectSection: (section: ISections) => dispatch({type: "select-section", section}),
    setUsuarios: (usuarios: Record<string, Record<string, string|number>[]>) => dispatch({type: "set-control-usuarios-usuarios", usuarios})
});

export default connect(mapStateToProps, mapDispatchToProps)(ConfirmacionEliminarUsuario);
